<template>
  <v-container fluid>
    <v-card class="mb-10">
      <v-card-title>ИИ-аудит</v-card-title>

      <v-card-text>
        <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="6" md="4" lg="3" xl="3" align="right">
                <ProjectSelector v-model="projects" single @input="resetPagination" />
              </v-col>
            </v-row>

            <v-row>
              <v-col align="right">
                <v-btn
                  color="success"
                  class="mt-3"
                  @click="loadReport(true)"
                >Поиск</v-btn>
              </v-col>
            </v-row>
        </v-form>
      </v-card-text>
    </v-card>


    <div>
      <div v-if="currentPrediction" class="cards_grid">

        <v-card class="pa-4">
          <div class="card-head text-center">
            <v-btn icon tile :disabled="prevDisabled" @click="previusPrediction">
              <v-icon>mdi-menu-left</v-icon>
            </v-btn>
            <v-chip label>{{ currentPrediction.date_from }} - {{ currentPrediction.date_to }}</v-chip>
            <v-btn icon tile :disabled="nextDisabled" @click="nextPrediction">
              <v-icon>mdi-menu-right</v-icon>
            </v-btn>
          </div>

          <div class="mt-2" v-html="currentPrediction.content"></div>
        </v-card>

      </div>

    </div>
  </v-container>
</template>


<script>
import { axios } from "~/plugins/axios"
import ProjectSelector from '~/components/partials/selectors/ProjectSelector'
import { mapActions } from 'vuex'

export default {
  name: 'PredictionReport',
  components: {
    ProjectSelector,
  },
  data() {
    return {
      projects: [],
      savedProject: null,
      limit: 10,
      page: 1,
      predictions: [],
      total: Infinity,
      currentPrediction: null,
      currentPredictionIndex: 0,
    }
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.isDark
    },

    prevDisabled() {
      return this.currentPredictionIndex >= this.total - 1
    },

    nextDisabled() {
      return this.currentPredictionIndex <= 0
    },
  },

  methods: {
    ...mapActions({
      setError: 'shared/setError',
      setLoading: 'shared/setLoading',
    }),

    resetPagination() {
      this.page = 1
    },

    async previusPrediction() {
      if (this.prevDisabled) return
      if (
        this.total !== this.predictions.length
        && this.currentPredictionIndex + 1 > this.predictions.length - 1
      ) {
        await this.loadReport(false)
      }
      this.currentPrediction = this.predictions[++this.currentPredictionIndex]
    },
    nextPrediction() {
      if (this.nextDisabled) return
      this.currentPrediction = this.predictions[--this.currentPredictionIndex]
    },

    async loadReport(bySearchBtn = false) {
      if (!this.$refs.form.validate()) return

      if (bySearchBtn) {
        this.resetPagination()
        this.savedProject = this.projects[0]
        this.predictions.length = 0
        this.currentPredictionIndex = 0
        this.currentPrediction = null
      }

      const payload = {
        project_id: this.savedProject,
        order_by: 'desc',
        limit: this.limit,
        page: this.page,
      }

      try {
        this.setLoading(true)
        const response = await axios.post('/api/reports/ai/get-prediction', payload)
        const data = response.data
        this.total = data.paginate.total
        if (this.total === 0) {
          this.predictions.length = 0
          return
        }
        this.page++

        this.predictions.push(...data.items)
        this.currentPrediction = this.predictions[this.currentPredictionIndex]
      } catch (error) {
        let payload = {message: error}
        if (error.response.data) payload = error.response.data
        this.setError(payload)
      } finally {
        this.setLoading(false)
      }
    },
  },

  mounted() {
    // this.projects.push(62) // debug
  }

}
</script>


<style scoped lang="scss">
// .cards_grid {
//   gap:16px;
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(min(450px, 100%), 1fr));
// }
</style>
